<template>
  <div
    class="position-relative text-banner overflow-hidden"
    :class="{content_bottom: show_content_at_bottom}">
    <lazy-image
      class="text-banner_bg"
      cover_img
      :src="img_src"
      :lazy_src="lazy_img_src"
      alt="banner image"
    />
    <div class="container position-relative text-banner_content">
      <div class="text-banner_content-inner">
        <div v-if="sub_title" class="text-banner_sub-title">{{sub_title}}</div>
        <div
          class="text-banner_title"
          :class="banner_title_classes">
          {{title}}
        </div>
        <html-block
          class="text-banner_desc"
          :content="content"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HtmlBlock from "../small_parts/HtmlBlock";
import LazyImage from "../small_parts/LazyImage.vue";

export default {
  name: "TextBanner",
  components: {LazyImage, HtmlBlock},
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    title_uppercase: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_smaller: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    sub_title: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    content: {
      type: String,
      default: '',
      admin_type: 'editor',
    },
    show_content_at_bottom: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    banner_title_classes() {
      return {
        upper_case: this.title_uppercase,
        smaller: this.title_smaller
      }
    }
  }
}
</script>
